<script>
export default {
  name: 'HistoryCreatingBeer'
}
</script>

<template>
  <div class="p-6 w-full mx-auto mt-36">
    <h1 class="text-3xl font-bold text-yellow-600 mb-4">Découvrez la bière Déglingo : Une révolution pour vos papilles ! 🍺</h1>

    <p class="text-gray-700 mb-6">
      Plongez dans l'univers unique de <strong>Déglingo</strong>, une bière artisanale au caractère bien trempé qui ne laisse personne indifférent. Brassée avec passion dans nos ateliers secrets nichés au cœur de la nature, Déglingo se distingue par une recette audacieuse qui bouscule les conventions.
    </p>

    <h2 class="text-2xl font-semibold text-gray-800 mb-3">Un goût qui détonne</h2>
    <ul class="list-disc pl-6 text-gray-700 mb-6">
      <li><strong>Des notes fruitées</strong> d'agrumes et de fruits tropicaux qui dansent sur votre palais.</li>
      <li><strong>Une touche de caramel doré</strong>, subtile mais inoubliable, qui équilibre l’amertume légère de ses houblons soigneusement sélectionnés.</li>
      <li>Un final en bouche <strong>léger et pétillant</strong>, parfait pour rafraîchir vos soirées endiablées.</li>
    </ul>

    <h2 class="text-2xl font-semibold text-gray-800 mb-3">Une fabrication extraordinaire</h2>
    <ul class="list-disc pl-6 text-gray-700 mb-6">
      <li>Brassée avec des ingrédients <strong>100% naturels et locaux</strong>, Déglingo mise sur la qualité et le savoir-faire.</li>
      <li>Sa fermentation lente et maîtrisée lui confère une texture soyeuse et une mousse aérienne, aussi douce qu’un nuage.</li>
      <li>Chaque bouteille est le fruit d’un travail minutieux, car chez Déglingo, on aime prendre le temps de bien faire les choses.</li>
    </ul>

    <h2 class="text-2xl font-semibold text-gray-800 mb-3">Des effets qui font la différence</h2>
    <ul class="list-disc pl-6 text-gray-700 mb-6">
      <li>Déglingo, ce n’est pas qu’une bière, c’est une <strong>expérience</strong>.</li>
      <li>Elle réveille votre créativité et apporte une bonne dose de folie pour dynamiser vos apéros entre amis.</li>
      <li>Avec son taux d’alcool parfaitement équilibré, elle sait être <strong>festive sans jamais être excessive</strong>.</li>
    </ul>

    <h2 class="text-2xl font-semibold text-gray-800 mb-3">Pour qui ?</h2>
    <p class="text-gray-700 mb-6">
      Pour les amateurs de bière en quête d'authenticité, pour les aventuriers du goût, et surtout pour <strong>ceux qui osent sortir des sentiers battus</strong>.
    </p>

    <div class="text-center mt-24">
      <p class="text-lg font-semibold text-yellow-600 mb-4">Alors, prêt à déguster <span class="italic">Déglingo</span> ?</p>
      <p class="text-gray-700">Faites vibrer vos soirées avec cette bière qui transforme chaque moment en fête.</p>
      <p class="text-lg text-gray-500 mt-2">🍻 À consommer avec modération, mais à aimer sans limite !</p>
    </div>
  </div>
</template>

<style scoped>

</style>